
import { Component, Mixins } from 'vue-property-decorator';
import Content from '@/features/dashboard/components/widgets/howItWorks/Content.vue';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { Widget } from '@/features/dashboard/types';
import { WidgetMixin } from '../widgetMixin';

export interface Step {
  img: string,
  name: string,
}

@Component({
  components: {
    Content,
  },
})
export default class HowItWorks extends Mixins(WidgetMixin) {
  private steps: Step[] = [
    {
      name: 'info',
      img: 'icon-step-1',
    },
    {
      name: 'prices',
      img: 'icon-step-2',
    },
    {
      name: 'purchase',
      img: 'icon-step-3',
    },
    {
      name: 'schedule',
      img: 'icon-step-4',
    },
    {
      name: 'track',
      img: 'icon-step-5',
    },
  ]

  get widget(): Widget {
    return this.$store.getters.getWidgets.howItWorks;
  }

  private handleApply(widgetName: string) {
    this.apply('big');

    this.$store.dispatch('syncDashboardSetting', {
      dashboardWidget: widgetName,
      visible: true,
      position: this.currentPosition,
      itemsShown: 0,
      customSettings: null,
    });

    if (this.position !== this.currentPosition) {
      this.$store.dispatch('patchDashboardSetting', { size: 'big' });
      eventBus.$emit(eventNames.SORT_DASHBOARD_WIDGETS_POSITION, 'big');
    }
  }
}
